import React, { useLayoutEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";
import useFlash from "go-alert/AlertMessage";
import handleError from "go-app/services/errors";
import { Exception } from "go-core/api/types";
import { LoadingContainer } from "go-core/components/Loading";
import SessionIdService from "../../../services/session/sessionIdService";

const SecurityLoginCodePage = () => {
	const { t } = useTranslation();
	const { addFlash } = useFlash();
	const [authorized, setAuthorized] = useState(false);
	const history = useHistory();

	const handleMessage = (event: MessageEvent<any>) => {
		try {
			if (event.data && typeof event.data === "string") {
				const parsed = JSON.parse(event.data);
				if (parsed.session_id && parsed.redirect_url) {
					setAuthorized(true);
					SessionIdService.update(parsed.session_id);
					history.push(parsed.redirect_url);
				}
			}
		} catch (err: Exception | unknown) {
			handleError.alert(err, addFlash);
		}
	};

	useLayoutEffect(() => {
		window.addEventListener("message", handleMessage);

		return () => {
			window.removeEventListener("message", handleMessage);
		};
	}, []);

	return (
		<div className="page">
			<div className="content d-flex align-items-center justify-content-center">
				{!authorized && (
					<LoadingContainer title={`${t("modules.security.field.pending_authorization.title")}...`} />
				)}
			</div>
		</div>
	);
};

export default SecurityLoginCodePage;
